<template>
    <div>
        <div class="table-box">
            <div class="search-box">
                <Button type="primary" @click="addSchoolYearModal=true">添加新学年</Button>
            </div>
            <Table ref="selection" :columns="columns" :data="school_year_data.body" ></Table>
            <div  class="page-box" v-if="school_year_data.page">
                <Page show-sizer
                      show-total
                      :page-size="school_year_data.page.page_size"
                      :current="school_year_data.page.current"
                      :total="school_year_data.page.count"
                      @on-change="currentPage"
                      @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <Modal
                v-model="addSchoolYearModal"
                title="添加新学年"
                width="400"
                @on-ok="addSchoolYear"
                @on-cancel="cancel">
            <div class="add-class-form">
                <Form :model="schoolYearFrom" label-position="right" :label-width="100">
                    <FormItem label="学年">
                        <Input v-model="schoolYearFrom.name" style="width: 70%" placeholder="请输入学年名称"></Input>
                    </FormItem>
                    <FormItem label="开始日期">
                        <DatePicker type="date" :value="editFrom.start_date" @on-change="startDate" placeholder="选择开始日期" style="width: 70%"></DatePicker>
                    </FormItem>
                    <FormItem label="结束日期">
                        <DatePicker type="date" :value="editFrom.end_date" @on-change="endDate"  placeholder="选择结束日期" style="width: 70%"></DatePicker>
                    </FormItem>
                </Form>
            </div>
        </Modal>
        <Modal
                v-model="editSchoolYearModal"
                title="编辑新学年"
                width="400"
                @on-ok="editSchoolYearOk"
                @on-cancel="cancel">
            <div class="add-class-form">
                <Form :model="editFrom" label-position="right" :label-width="100">
                    <FormItem label="学年">
                        <Input v-model="editFrom.name" style="width: 70%" placeholder="请输入班级名称"></Input>
                    </FormItem>
                    <FormItem label="开始日期">
                        <DatePicker type="date" :value="editFrom.start_date" placeholder="选择开始日期" @on-change="editStartDate" style="width: 70%"></DatePicker>
                    </FormItem>
                    <FormItem label="结束日期">
                        <DatePicker type="date" :value="editFrom.end_date" placeholder="选择结束日期" @on-change="editEndDate" style="width: 70%"></DatePicker>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import moment from "moment";
    export default {
        name: "schoolYear",
        data(){
            return{
                addSchoolYearModal:false,
                editSchoolYearModal:false,
                page_num:1,
                page_size:20,
                editFrom:{
                    name:'',
                    start_date:'',
                    end_date:''
                },
                columns: [
                    {
                        title: 'ID',
                        key: 'id',
                        sortable: true
                    },
                    {
                        title: '学年',
                        key: 'name'
                    },
                    {
                        title: '时间',
                        key: 'time',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                },`${moment(params.row.start_date).format('YYYY-MM-DD')}至${moment(params.row.end_date).format('YYYY-MM-DD')}` ),
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editRowData(params.row)
                                        }
                                    }
                                }, '管理'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteRow(params)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
                editSchoolYearId:null,
                schoolYearFrom:{
                    name:'',
                    start_date:'',
                    end_date:''
                }
            }
        },
        computed: {
            ...mapState({
                school_year_data: state => state.rangeManage.school_year_data,
            }),
        },
        methods: {
            ...mapActions({
                getSchoolYear: 'rangeManage/getSchoolYear',
                createSchoolYear:'rangeManage/createSchoolYear',
                editSchoolYear:'rangeManage/editSchoolYear',
                delSchoolYear:'rangeManage/delSchoolYear'
            }),
            addSchoolYear(){
                let _this = this
                this.createSchoolYear({
                    data:_this.schoolYearFrom,
                    callback:res =>{
                        _this.$Message.success('添加学年成功!')
                        _this.initSchoolYear()
                    }
                })
            },
            editSchoolYearOk(){
                let _this = this
                this.editSchoolYear({
                    data:{
                        schoolyear_id:_this.editSchoolYearId,
                        data:_this.editFrom
                    },
                    callback:res =>{
                        _this.$Message.success('编辑学年成功!')
                        _this.initSchoolYear()
                    }
                })
            },
            ok() {
                console.log(this.questionType)
            },
            cancel(){

            },
            editStartDate(date){
                this.editFrom.start_date = date
            },
            editEndDate(date){
                this.editFrom.end_date = date
            },
            startDate(date){
                this.schoolYearFrom.start_date = date
            },
            endDate(date){
                this.schoolYearFrom.end_date = date
            },
            deleteRow(row){
                let _this = this
                this.delSchoolYear({
                    schoolyear_id:row.row.id,
                    callback:res =>{
                        _this.$Message.success('删除学年成功!')
                        _this.initSchoolYear()
                    }
                })
            },
            editRowData(row){
                this.editSchoolYearModal = true
                this.editSchoolYearId = row.id
                this.editFrom = {
                    name:row.name,
                    start_date:row.start_date,
                    end_date:row.end_date
                }
            },
            currentPage(num){
                this.page_num = num
                this.initSchoolYear()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initSchoolYear()
            },
            initSchoolYear(){
                let _this = this
                this.getSchoolYear({
                    sort:'-name|ctime',
                    page_num:_this.page_num,
                    page_size:_this.page_size,
                })
            }
        },
        mounted () {
            this.initSchoolYear()
        },
    }
</script>

<style scoped lang="less">
    @import "../../style/index";

</style>
